import _readOnlyError from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/readOnlyError.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'cake_brands',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      enumCols: {
        '5-1': '5'
      }
    };
  },
  computed: {
    Styles: function Styles() {
      var cols = this.value.config.cols;
      return {
        '--templateColumns': this.enumCols[cols] || cols
      };
    },
    cakeContentClass: function cakeContentClass() {
      var _this$value$config = this.value.config,
        _this$value$config$ty = _this$value$config.type,
        type = _this$value$config$ty === void 0 ? 1 : _this$value$config$ty,
        bg_style = _this$value$config.bg_style,
        border_style = _this$value$config.border_style,
        border_none = _this$value$config.border_none;
      var className = [];
      type === 2 && className.push('icon_style');
      if (type === 1 || bg_style !== 2) {
        return className.join(' ');
      }
      className.push('border');
      if (border_style == '2') {
        var enumClass = {
          1: 'top',
          2: 'right',
          3: 'bottom',
          4: 'left'
        };
        var borderNoneList = border_none.map(function (i) {
          return "border-hide-".concat(enumClass[i]);
        });
        className = className.concat(borderNoneList);
      }
      return className.join(' ');
    },
    brandList: function brandList() {
      var _brandList, _brandList2;
      var _this$value$config2 = this.value.config,
        _this$value$config2$r = _this$value$config2.rows,
        rows = _this$value$config2$r === void 0 ? 2 : _this$value$config2$r,
        _this$value$config2$t = _this$value$config2.type,
        type = _this$value$config2$t === void 0 ? 1 : _this$value$config2$t,
        _this$value$config2$b = _this$value$config2.brandList,
        brandList = _this$value$config2$b === void 0 ? [] : _this$value$config2$b,
        _this$value$config2$c = _this$value$config2.cols,
        cols = _this$value$config2$c === void 0 ? 4 : _this$value$config2$c;
      var num = this.enumCols[cols] || cols;
      return type === 1 ? (_brandList = brandList) === null || _brandList === void 0 ? void 0 : _brandList.slice(0, rows * 4) : (_brandList2 = brandList) === null || _brandList2 === void 0 ? void 0 : _brandList2.slice(0, rows * num);
    }
  }
};